<!--  -->
<template>
  <div class="publicItems">
    <div class="selectionArea">
      <div class="item">
        <span class="title">小程序名称</span>
        <el-input
          v-model="parameter.account_name"
          style="width: 200px;"
          placeholder="请输入内容"
        />
      </div>
      <div class="item">
        <span class="title">小程序app_id</span>
        <el-input
          v-model="parameter.app_id"
          style="width: 200px;"
          placeholder="请输入内容"
        />
      </div>
      <el-button
        type="primary"
        icon="el-icon-search"
        @click="search"
      >搜索</el-button>
      <el-button
        type="primary"
        icon="el-icon-refresh-left"
        @click="reset"
      >重置</el-button>
      <el-button
        type="success"
        icon="el-icon-news"
        @click="addwechatwe"
      >新增</el-button>
    </div>
    <div>
      <el-table
        :data="tableData"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="url_link"
          label="链接"
          align="center"
        />
        <el-table-column
          prop="app_id"
          label="小程序app_id"
          align="center"
        />

        <el-table-column
          prop="created_at"
          label="授权时间"
          align="center"
        />
      </el-table>
    </div>
    <el-dialog
      title="小程序链接"
      :visible.sync="dialogVisible"
      :destroy-on-close="true"
      :show="true"
      width="600px"
    >
      <addialog @updata="updata" />
    </el-dialog>
    <pagination-right
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />

  </div>
</template>

<script>
import { programmanageurlLinkindex } from '@/api/hugeAdvertGroup.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
import addialog from './components/addialog.vue'
export default {
  components: { PaginationRight, addialog },
  data() {
    return {
      tableData: [],
      total: null,
      parameter: {
        page: 1,
        page_size: 10,
        app_id: '',
        account_name: ''
      },
      dialogVisible: false
    }
  },
  created() {
    this.list()
  },
  mounted() {},
  methods: {
    async list() {
      const data = await programmanageurlLinkindex(this.parameter)
      this.tableData = data.data.list
      this.total = data.data.total
      console.log('data', data)
    },
    // 搜索
    search() {
      this.parameter.page = 1
      this.list()
    },

    // 重置
    reset() {
      this.parameter = {
        page: 1,
        page_size: 10,
        app_id: '',
        account_name: ''
      }
      this.list()
    },
    fetchPageSize(s) {
      this.parameter.page_size = s
      this.list()
    },

    fetchCurrentPage(s) {
      this.parameter.page = s
      this.list()
    },
    addwechatwe() {
      this.dialogVisible = true
    },
    updata() {
      this.dialogVisible = false
      this.list()
    }
  }
}
</script>
<style src="@/styles/public1.css"></style>
<style scoped lang="less">
.selectionArea {
  display: flex;
}

.content {
  .item {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    .item_title {
      display: inline-block;
      width: 100px;
    }
    .item_input {
      width: 200px;
    }
  }
}

.item {
  display: flex;
  align-items: center;
  margin-right: 20px;
}

.title {
  display: inline-block;
  margin-right: 10px;
}
</style>
